<div class="notifications__item">
  <div class="notifications__avatar" *ngIf="notificationUserType">
    <app-ph-avatar
      size="40"
      [username]="
        item.parameters.sign_project_by_name
          ? storage.setAvatarInitials(item.parameters.display_name, '')
          : storage.setAvatarInitials(item.parameters.name, item.parameters.surname)
      "
    ></app-ph-avatar>
  </div>
  <div class="notifications__icon" *ngIf="notificationAchievementType">
    <img src="assets/img/icons/badge.svg" />
  </div>
  <div
    class="notifications__project"
    *ngIf="notificationProjectType"
    [ngClass]="'notifications__' + item.type"
  >
    <img src="assets/img/icons/leaf-green.svg" *ngIf="item.type === 'project_was_accepted'" />
    <span *ngIf="item.type === 'project_was_donated'">$</span>
    <img
      src="assets/img/icons/not-verified.svg"
      *ngIf="item.type === 'project_was_decline' || item.type === 'declined'"
    />
  </div>
  <div class="notifications__body">
    <div class="notifications__text">
      {{ item.content }}
    </div>
    <div class="notifications__time">{{ item.dateFromNow }}</div>
  </div>
  <span class="notifications__dot" *ngIf="!item.is_read"></span>
</div>
